// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-xs>
    <v-card>
      <v-toolbar flat class="title">
        <v-btn icon @click="exit"><v-icon>arrow_back</v-icon></v-btn>
          Log - {{ logTime }}
        <v-spacer></v-spacer>
        <a :href="downloadLink" :download="downloadName" style="text-decoration: none;">
          <v-btn light color="blue">Download</v-btn>
          </a>
        <v-btn v-if="canDelete" light color="error" @click.stop="showDeleteDialog = true">Delete</v-btn>
      </v-toolbar>
      <v-card-text style="white-space: pre-wrap;">
        {{ file }}
      </v-card-text>
    </v-card> 

    <v-dialog v-model="showDeleteDialog" max-width="300px">
      <v-card>
        <v-card-title>
          <div class="headline">Delete?</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete this file?  This action cannot be undone.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDeleteDialog = false">Cancel</v-btn>
          <v-btn flat color="red" @click.native="deleteFile">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import {checkPermission} from 'vue-common/components/user'
import {ENDPOINT} from '@/shared/constants'
import {PERMISSIONS} from 'vue-common/components/constants'
// import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'

import ApiRequests from '@/api/ApiRequests'

export default {
  data () {
    return {
      file: '',
      metadata: {},
      showDeleteDialog: false
    }
  },

  created () {
    ApiRequests.getFile(this.$route.params.id).then(response => {
      this.file = response.data
    })

    ApiRequests.getFileMeta(this.$route.params.id).then(response => {
      this.metadata = response.data
    })
  },

  computed: {
    ...mapGetters([
      'accessRules'
    ]),

    canDelete: function () {
      return checkPermission(this.accessRules, 'files', PERMISSIONS.DELETE)
    },

    downloadLink: function () {
      return ENDPOINT + 'files/' + this.$route.params.id
    },

    downloadName: function () {
      var name = 'log_'
      if (this.metadata.tags) {
        if (this.metadata.tags[0]) {
          name = name + this.metadata.tags[0] + '_'
        }
      }
      name = name + moment(this.metadata.timestamp).format('YYYYMMDDHHmm') + '.log'
      return name
    },

    logTime: function () {
      return moment(this.metadata.timestamp).format('YYYY-MM-DD hh:mm a')
    }
  },

  methods: {
    deleteFile: function () {
      ApiRequests.deleteFile(this.$route.params.id).then(() => {
        this.exit()
      })
    },

    exit: function () {
      this.$router.go(-1)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/FileEdit.vue